var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"facebook--btn",attrs:{"icon":"","href":_vm.twitterLink}},[_c('v-icon',[_vm._v(_vm._s(_vm.twitterIcon))])],1),_c('v-btn',{staticClass:"twitter--btn",attrs:{"icon":"","href":_vm.facebookLink}},[_c('v-icon',[_vm._v(_vm._s(_vm.facebookIcon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }